import { FormikProps } from "formik";
import React from "react";
import Button from "../Button";
import PasswordInput from "../PasswordInput";

interface PropTypes {
  step3Form: FormikProps<{ password: string }>;
}

const NewPassword = ({ step3Form }: PropTypes) => {
  return (
    <div className='w-full lg:w-[30%]'>
      <form
        onSubmit={(e) => {
          e.preventDefault();  // ✅ prevents page reload
          step3Form.handleSubmit(e);
        }}
        className="bg-white flex flex-col gap-4 p-4 mx-4 lg:mx-0 rounded-xl shadow-lg"
      >
        <p className="text-gray-500">Enter new password</p>
        <PasswordInput
          type="password"
          name="password"
          isInvalid={Boolean(
            step3Form.touched.password && step3Form.errors.password
          )}
          onChange={step3Form.handleChange}
          value={step3Form.values.password}
          onBlur={step3Form.handleBlur}
          error={step3Form.errors.password}
          placeholder="Please enter password"
          label="Enter password"
          containerClassName='w-full'
        />
        <Button
          isLoading={step3Form.isSubmitting}
          type="submit"
          className="py-1"
        >
          Save
        </Button>
      </form>
    </div>


  );
};

export default NewPassword;
